import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, TextField } from 'react-admin';

import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { DatagridWithBlockProps } from '../../../components/_helpers/props/DatagridProps';
import { DateFormatField } from '../../../components/fields/DateFormatField';

const defaultSort = { field: 'id', order: 'DESC' };


export const HolidaysList = props => {

	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			sort={defaultSort}
			pagination={null}
			actions={null}
		>
			<ScrollingWrapper>
				<Datagrid
					{...DatagridWithBlockProps}
					rowClick={null}
					size="small"
				>
					{/* <TextField source="id" sortable={false} /> */}
					<DateFormatField source="date" sortable={false} />
					<TextField source="name" sortable={false} />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
}
